import { Radio } from '@thanx/uikit/radio'
import { Text } from '@thanx/uikit/text'
import StatusBadge from 'components/StatusBadge'
import useDispatch from 'hooks/useDispatch'
import { buildTranslate } from 'locales'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectOrderingEnabled } from 'selectors/merchant'
import { updatePlacement } from 'slices/Cms/Content/AppNavigation/Style'
import { selectStylePlacement } from 'slices/Cms/Content/AppNavigation/Style/selectors'

const t = buildTranslate('cms.content.app_navigation.style')

const Placement: React.FC = () => {
  const dispatch = useDispatch()
  const placementState = useSelector(selectStylePlacement)
  const orderingEnabled = useSelector(selectOrderingEnabled)

  const setTopPlacement = () => {
    if (orderingEnabled) {
      dispatch(updatePlacement('top'))
    }
  }
  const setBottomPlacement = () => {
    dispatch(updatePlacement('bottom'))
  }

  return (
    <div className="mb-l" data-testid="placement-container">
      <Text.Header4 className="mb-m" data-testid="placement-title">
        {t('placement.title')}
      </Text.Header4>
      <div className="mb-m">
        <div className="align-items-center d-flex flex-row">
          <Radio
            className="font-size-14 grey-70"
            value="bottom"
            checked={placementState.placement === 'bottom'}
            data-testid="bottom-placement-radio"
            onChange={setBottomPlacement}
          >
            {t('placement.bottom_of_page')}
          </Radio>
          <StatusBadge
            type={'new'}
            text={t('placement.best_for_in_store_check_in')}
          />
        </div>
        {placementState.placement === 'bottom' && (
          <div className="ml-l">
            <Text.BodyText4
              tag="div"
              color="grey70"
              className="small"
              data-testid="placement-description"
            >
              {t('placement.description')}
            </Text.BodyText4>
          </div>
        )}
        <div className="d-flex flex-row align-items-center">
          <Radio
            className="font-size-14 grey-70"
            value="top"
            checked={placementState.placement === 'top' && orderingEnabled}
            disabled={!orderingEnabled}
            onChange={setTopPlacement}
            data-testid="top-placement-radio"
          >
            {t('placement.top_of_page')}
          </Radio>
        </div>
        {placementState.placement === 'top' && (
          <div className="ml-l">
            <Text.BodyText4
              tag="div"
              color="grey70"
              className="small"
              data-testid="placement-description"
            >
              {t('placement.description_top')}
            </Text.BodyText4>
          </div>
        )}
      </div>
    </div>
  )
}

export default Placement
